<template>
  <div id="app">
    <NavBar v-if="!isAdminRoute" />
    <router-view />
    <Footer v-if="!isAdminRoute" />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import NavBar from "./components/NavBar.vue";

export default {
  components: { NavBar, Footer },
  data() {
    return {
      isAdminRoute: false,
    };
  },
  watch: {
    // Rota değişince kontrol et
    $route(to) {
      this.isAdminRoute = to.path.startsWith("/admin");
    },
  },
  created() {
    // Sayfa ilk açıldığında kontrol et
    this.isAdminRoute = this.$route.path.startsWith("/admin");
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  background-color: #f9f9f9;
  color: #333;
}

html, body, #app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#app > *:last-child {
  margin-top: auto;
}
</style>
